import React from 'react'

function Footer() {
  return (
    <div className="footer w-[1200px] m-auto max-sm:w-full border-t-[1px] border-white py-5 max-sm:py-2">
     <p className='text-3xl italic text-slate-900 max-sm:text-xl '>@Abhiifour</p>
    </div>
  )
}

export default Footer